export default {
  header: "Notes",
  view: "notes",
  weather: {},
  toDos: [],
  goals: [],
  username: "",
  date: new Date()
};
